import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M24,21v2H0v-2H11v-2H1v-3C1,10.272,5.402,5.558,11,5.051V3h-2V1h6V3h-2v2.051c5.598,.508,10,5.221,10,10.949v3H13v2h11Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/reception-icon.jsx